<template>
    <div class="row">
        <!-- main title -->
        <div class="col-12">
            <div class="main__title">
                <h2>{{title}}</h2>

                <span class="main__title-stat">تعداد کل : {{items.length}}</span>

                <div class="main__title-wrap">
                    <!-- filter sort -->
<!--                    <div class="filter" id="filter__sort">-->
<!--                        <span class="filter__item-label">ترتیب:</span>-->

<!--                        <div class="filter__item-btn dropdown-toggle" role="navigation" id="filter-sort" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">-->
<!--                            <input type="button" value="Date created">-->
<!--                            <span></span>-->
<!--                        </div>-->

<!--                        <ul class="filter__item-menu dropdown-menu scrollbar-dropdown" aria-labelledby="filter-sort">-->
<!--                            <li>Date created</li>-->
<!--                            <li>Rating</li>-->
<!--                            <li>Views</li>-->
<!--                        </ul>-->
<!--                    </div>-->
                    <!-- end filter sort -->

                    <!-- search -->
                    <form action="#" class="main__title-form">
                        <input
                                class="text"
                                type="text"
                                placeholder="جستجو"
                                @input="tableFilterChange($event.target.value, 'input')"
                                @change="tableFilterChange($event.target.value, 'change')"
                                :value="tableFilterState"
                        >
                        <button type="button">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.25998" cy="8.25995" r="7.48191" stroke="#2F80ED" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle><path d="M13.4637 13.8523L16.3971 16.778" stroke="#2F80ED" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        </button>
                    </form>
                    <!-- end search -->
                </div>
            </div>
        </div>
    <div class="col-12">
        <div v-if="itemsPerPageSelect || tableFilter" class="row my-2 mx-0">
            <div
                    class="col-sm-6 form-inline p-0"
                    v-if="tableFilter"
            >
                <label class="mr-2">{{tableFilterData.label}}</label>
                <input
                        class="form-control"
                        type="text"
                        :placeholder="tableFilterData.placeholder"
                        @input="tableFilterChange($event.target.value, 'input')"
                        @change="tableFilterChange($event.target.value, 'change')"
                        :value="tableFilterState"
                >
            </div>

            <div
                    v-if="itemsPerPageSelect"
                    class="col-sm-6 p-0"
                    :class="{ 'offset-sm-6': !tableFilter }"
            >
                <div class="form-inline justify-content-sm-end">
                    <label class="mr-2">{{paginationSelect.label}}</label>
                    <select
                            class="form-control"
                            @change="paginationChange"
                    >
                        <option value="" selected disabled hidden>
                            {{perPageItems}}
                        </option>
                        <option
                                v-for="(number, key) in paginationSelect.values"
                                :val="number"
                                :key="key"
                        >
                            {{number}}
                        </option>
                    </select>
                </div>
            </div>
        </div>


        <slot name="over-table"/>
        <div :style="tableHeight"
             style="
             overflow: hidden;
             width: 100%;
"
             :class="`main__table-wrap position-relative ${responsive ? 'table-responsive' : '' }`">
            <table style="position: relative;" :class="tableClasses" >
                <thead style="position: sticky;top:-1px;z-index: 100;background: #131720;color: white">
                <slot name="thead-top"/>
                <tr v-if="header">
                    <template v-for="(name, index) in columnNames" :key="index">
                        <th
                                @click="changeSort(rawColumnNames[index], index)"
                                :class="[headerClass(index), sortingIconStyles]"
                                :style="headerStyles(index)"

                        >
                            <slot :name="`${rawColumnNames[index]}-header`">
                                <div>{{name}}</div>
                            </slot>
                            <slot
                                    v-if="isSortable(index)"
                                    name="sorting-icon"
                                    :state="getIconState(index)"
                                    :classes="iconClasses(index)"
                            >
<!--                                <CIcon-->
<!--                                        width="18"-->
<!--                                        :content="$options.icons.cilArrowTop"-->
<!--                                        :class="iconClasses(index)"-->
<!--                                />-->
                                <label :class="iconClasses(index)">^</label>

                            </slot>
                        </th>
                    </template>
                </tr>

                <tr v-if="columnFilter" class="table-sm" >
                    <template v-for="(colName, index) in rawColumnNames" :key="index">
                        <th :class="headerClass(index)" >
                            <slot :name="`${rawColumnNames[index]}-filter`" >
                                <input
                                        style="height: 40px;
    border-radius: 16px;
    background-color: #151f30;
    border: none;
    padding: 0 10px ;
    font-size: 14px;
    color: #fff;
    width: 100%;
    position: relative;
    z-index: 1;"
                                        v-if="!fields || fields[index].filter !== false"
                                        class="form-control form-control-sm"
                                        @input="columnFilterEvent(colName, $event.target.value, 'input')"
                                        @change="columnFilterEvent(colName, $event.target.value, 'change')"
                                        :value="columnFilterState[colName]"
                                />
                            </slot>
                        </th>
                    </template>
                </tr>
                </thead>


                <tbody
                        :style="clickableRows ? 'cursor:pointer;': null"
                        class="position-relative"
                >
                <template v-for="(item, itemIndex) in currentItems" :key="itemIndex">
                    <tr
                            @click="rowClicked(item, itemIndex + firstItemIndex, $event)"
                            :class="item._classes"
                            :tabindex="clickableRows ? 0 : null"

                            :style="get_sticky_style(itemIndex)"
                    >
                        <template v-for="(colName, index) in rawColumnNames" >
                            <slot

                                    v-if="$slots[colName]"
                                    :name="colName"
                                    :item="item"
                                    :index="itemIndex + firstItemIndex"
                            />
                            <td
                                    v-else
                                    :class="cellClass(item, colName, index)"
                                    :key="index"
                            >
                                <div class="main__table-text">
                                    {{ String(item[colName]) }}
                                </div>

                            </td>
                        </template>
                    </tr>
                    <tr
                            v-if="$slots.details"
                            @click="rowClicked(item, itemIndex + firstItemIndex, $event, true)"
                            :class="'p-0'"
                            style="border:none !important"
                            :key="'details' + itemIndex"
                    >
                        <td
                                :colspan="colspan"
                                class="p-0"
                                style="border:none !important"
                        >
                            <slot
                                    name="details"
                                    :item="item"
                                    :index="itemIndex + firstItemIndex"
                            />
                        </td>
                    </tr>
                </template>
                <tr v-if="!currentItems.length">
                    <td :colspan="colspan">
                        <slot name="no-items-view">
                            <div class="text-center my-5">
                                <h2>
                                    {{ noItemsText }}
                                    icon ban
                                </h2>
                            </div>
                        </slot>
                    </td>
                </tr>
                </tbody>


                <tfoot v-if="footer && currentItems.length > 0">
                <tr>
                    <template v-for="(name, index) in columnNames" :key="index">
                        <th
                                @click="changeSort(rawColumnNames[index], index)"
                                :class="[headerClass(index), sortingIconStyles]"
                                :style="headerStyles(index)"

                        >
                            <slot :name="`${rawColumnNames[index]}-header`">
                                <div>{{name}}</div>
                            </slot>
                            <slot
                                    v-if="isSortable(index)"
                                    name="sorting-icon"
                                    :state="getIconState(index)"
                            >
<!--                                <CIcon-->
<!--                                        width="18"-->
<!--                                        :content="$options.icons.cilArrowTop"-->
<!--                                        :class="iconClasses(index)"-->
<!--                                />-->
                                <label :class="iconClasses(index)">^</label>
                            </slot>
                        </th>
                    </template>
                </tr>
                </tfoot>
                <tfoot style="position: sticky;bottom:-1px;z-index: 100;background: #131720;color: white">
                <slot name="caption" />
                </tfoot>
            </table>

            <slot name="loading" v-if="loading">

            </slot>
        </div>

        <slot name="under-table"/>


        <CPagination
                v-if="pagination"
                v-show="totalPages > 1"
                v-model:activePage="page"
                :pages="totalPages"
                v-bind="typeof pagination === 'object' ? pagination : null"
        />
    </div>
    </div>
</template>

<script>


    import CPagination from './CPagination'
    // import CIcon from '@coreui/icons-vue/src/CIconRaw.vue'
    // import { cilArrowTop, cilBan } from '@coreui/icons'

    export default {
        name: 'CDataTable',
        // icons: { cilArrowTop, cilBan },
        components: {
            CPagination,
            // CIcon
        },
        props: {
            sticky_zero: {type: Boolean, default: false},

            items: Array,
            fields: Array,
            itemsPerPage: {
                type: Number,
                default: 10
            },
            activePage: Number,
            pagination: [Boolean, Object],
            addTableClasses: [String, Array, Object],
            responsive: {
                type: Boolean,
                default: true
            },
            size: String,
            title: String,
            height:String,
            dark: Boolean,
            striped: Boolean,
            fixed: Boolean,
            hover: Boolean,
            border: Boolean,
            outlined: Boolean,
            itemsPerPageSelect: [Boolean, Object],
            sorter: [Boolean, Object],
            tableFilter: [Boolean, Object],
            columnFilter: [Boolean, Object],
            sorterValue: {
                type: Object,
                default: () => { return {} }
            },
            tableFilterValue: String,
            columnFilterValue: Object,
            header: {
                type: Boolean,
                default: true
            },
            footer: Boolean,
            loading: Boolean,
            clickableRows: Boolean,
            noItemsView: Object
        },
        data () {
            return {
                tableFilterState: this.tableFilterValue,
                columnFilterState: {},
                sorterState: {
                    column: null,
                    asc: true
                },
                page: this.activePage || 1,
                perPageItems: this.itemsPerPage,
                passedItems: this.items || []
            }
        },
        watch: {
            itemsPerPage (val) {
                this.perPageItems = val
            },
            sorterValue: {
                immediate: true,
                handler (val) {
                    const asc = val.asc === false ? false : true
                    this.sorterState = Object.assign({}, { asc, column: val.column })
                }
            },
            tableFilterValue (val) {
                this.tableFilterState = val
            },
            columnFilterValue: {
                immediate: true,
                handler (val) {
                    this.columnFilterState = Object.assign({}, val)
                }
            },
            items (val, oldVal) {
                if (val && oldVal && this.objectsAreIdentical(val, oldVal)) {
                    return
                }
                this.passedItems = val || []
            },
            totalPages: {
                immediate: true,
                handler (val) {
                    this.$emit('pages-change', val)
                }
            },
            computedPage (val) {
                this.$emit('page-change', val)
            },
            sortedItems: {
                immediate: true,
                handler (val, oldVal) {
                    if (val && oldVal && this.objectsAreIdentical(val, oldVal)) {
                        return
                    }
                    this.$emit('filtered-items-change', val)
                }
            }
        },
        computed: {
            tableHeight(){
                return 'height:'+this.height+";"
            },
            columnFiltered () {
                let items = this.passedItems
                if (this.columnFilter && this.columnFilter.external) {
                    return items
                }
                Object.entries(this.columnFilterState).forEach(([key, value]) => {
                    const columnFilter = String(value).toLowerCase()
                    if (columnFilter && this.rawColumnNames.includes(key)) {
                        items = items.filter(item => {
                            return String(item[key]).toLowerCase().includes(columnFilter)
                        })
                    }
                })
                return items
            },
            filterableCols () {
                return this.rawColumnNames.filter(name => {
                    return this.generatedColumnNames.includes(name)
                })
            },
            tableFiltered () {
                let items = this.columnFiltered
                if (!this.tableFilterState || (this.tableFilter && this.tableFilter.external)) {
                    return items
                }
                const filter = this.tableFilterState.toLowerCase()
                const hasFilter = (item) => String(item).toLowerCase().includes(filter)
                items = items.filter(item => {
                    return this.filterableCols.filter(key => hasFilter(item[key])).length
                })
                return items
            },
            sortedItems () {
                var self=this;
                const col = this.sorterState.column
                if (!col || !this.rawColumnNames.includes(col) || this.sorter.external) {
                    return this.tableFiltered
                }
                //if values in column are to be sorted by numeric value they all have to be type number
                const flip = this.sorterState.asc ? 1 : -1
                try {
                    if (flip == 1) {
                        return this.tableFiltered.slice().sort(function (item, item2)  {
                            if(self.sticky_zero){
                                if(item.id=="0") return -1;
                                if(item2.id=="0") return 1;
                            }
                            return   item[col].localeCompare(item2[col], undefined, {
                                numeric: true,
                                sensitivity: 'base'
                            })
                        })

                    } else {
                        return this.tableFiltered.slice().sort(function (item, item2)  {
                            if(self.sticky_zero){
                                if(item.id=="0") return 1;
                                if(item2.id=="0") return -1;
                            }

                            return   item[col].localeCompare(item2[col], undefined, {
                                numeric: true,
                                sensitivity: 'base'
                            })
                        }).reverse()
                    }
                }catch (error){
                    console.log("sorter in catch",error)

                }
                return this.tableFiltered.slice().sort((item, item2) => {

                    const value  = item[col]
                    const value2 = item2[col]

                    if(this.sticky_zero){
                        if(item.id=="0") return -1;
                        if(item2.id=="0") return 1;
                    }
                    const a = typeof value === 'number' ? value : String(value).toLowerCase()
                    const b = typeof value2 === 'number' ? value2 : String(value2).toLowerCase()
                    return a > b ? 1 * flip : b > a ? -1 * flip : 0
                })
            },
            firstItemIndex () {
                return (this.computedPage - 1) * this.perPageItems || 0
            },
            paginatedItems () {
                return this.sortedItems.slice(
                    this.firstItemIndex,
                    this.firstItemIndex + this.perPageItems
                )
            },
            currentItems () {
                return this.computedPage ? this.paginatedItems : this.sortedItems
            },
            totalPages () {
                return Math.ceil((this.sortedItems.length)/ this.perPageItems) || 1
            },
            computedPage () {
                return this.pagination ? this.page : this.activePage
            },
            generatedColumnNames () {
                return Object.keys(this.passedItems[0] || {}).filter(el => el.charAt(0) !== '_')
            },
            rawColumnNames () {
                if (this.fields) {
                    return this.fields.map(el => el.key || el)
                }
                return this.generatedColumnNames
            },
            columnNames () {
                if (this.fields) {
                    return this.fields.map(f => {
                        return f.label !== undefined ? f.label : this.pretifyName(f.key || f)
                    })
                }
                return this.rawColumnNames.map(el => this.pretifyName(el))
            },
            tableClasses () {
                return [
                    'table main__table',
                    this.addTableClasses,
                    {
                        [`table-${this.size}`]: this.size,
                        'table-dark': this.dark,
                        'table-striped': this.striped,
                        'table-fixed': this.fixed,
                        'table-hover': this.hover,
                        'table-bordered': this.border,
                        'border': this.outlined
                    }
                ]
            },
            sortingIconStyles () {
                return {'position-relative pr-4' : this.sorter }
            },
            colspan () {
                return this.rawColumnNames.length
            },
            tableFilterData () {
                return {
                    label: this.tableFilter.label || 'Filter:',
                    placeholder: this.tableFilter.placeholder || 'type string...'
                }
            },
            paginationSelect () {
                return {
                    label: this.itemsPerPageSelect.label || 'Items per page:',
                    values: this.itemsPerPageSelect.values || [5, 10, 20, 50]
                }
            },
            noItemsText () {
                const customValues = this.noItemsView || {}
                if (this.passedItems.length) {
                    return customValues.noResults || 'No filtering results'
                }
                return customValues.noItems || 'No items'
            }
        },
        methods: {
            get_sticky_style(index){
                if(this.sticky_zero && index==0){
                    return " position:sticky;top:22px;background:white"
                }else{
                    return " "

                }
            },
            changeSort (column, index) {
                if (!this.isSortable(index)) {
                    return
                }
                //if column changed or sort was descending change asc to true
                const state = this.sorterState
                const columnRepeated = state.column === column
                if (!this.sorter || !this.sorter.resetable) {
                    state.column = column
                } else {
                    state.column = columnRepeated && state.asc === false ? null : column
                }
                state.asc = !(columnRepeated && state.asc)
                this.$emit('update:sorter-value', this.sorterState)
            },
            columnFilterEvent (colName, value, type) {
                const isLazy = this.columnFilter && this.columnFilter.lazy === true
                if (isLazy && type === 'input' || !isLazy && type === 'change') {
                    return
                }
                // this.$set(this.columnFilterState, colName, value)
                this.columnFilterState[colName]= value
                this.$emit('update:column-filter-value', this.columnFilterState)
            },
            tableFilterChange (value, type) {
                const isLazy = this.tableFilter && this.tableFilter.lazy === true
                if (isLazy && type === 'input' || !isLazy && type === 'change') {
                    return
                }
                this.tableFilterState = value
                this.$emit('update:table-filter-value', this.tableFilterState)
            },
            pretifyName (name) {
                return name.replace(/[-_.]/g, ' ')
                    .replace(/ +/g, ' ')
                    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
                    .split(' ')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ')
            },
            cellClass (item, colName, index) {
                let classes = []
                if (item._cellClasses && item._cellClasses[colName]) {
                    classes.push(item._cellClasses[colName])
                }
                if (this.fields && this.fields[index]._classes) {
                    classes.push(this.fields[index]._classes)
                }
                return classes
            },
            isSortable (index) {
                return this.sorter && (!this.fields || this.fields[index].sorter !== false)
            },
            headerClass (index) {
                const fields = this.fields
                return fields && fields[index]._classes ? fields[index]._classes : ''
            },
            headerStyles (index) {
                let style = 'vertical-align:middle;overflow:hidden;'
                if (this.isSortable(index)) {
                    style += `cursor:pointer;`
                }
                if (this.fields && this.fields[index] && this.fields[index]._style) {
                    style += this.fields[index]._style
                }
                style+=";text-align:center;"
                return style
            },
            rowClicked (item, index, e, detailsClick = false) {
                this.$emit(
                    'row-clicked', item, index, this.getClickedColumnName(e, detailsClick), e
                )
            },
            getClickedColumnName (e, detailsClick) {
                if (detailsClick) {
                    return 'details'
                } else {
                    const children = Array.from(e.target.closest('tr').children)
                    const clickedCell = children.filter(child => child.contains(e.target))[0]
                    return this.rawColumnNames[children.indexOf(clickedCell)]
                }
            },
            getIconState (index) {
                const direction = this.sorterState.asc ? 'asc' : 'desc'
                return this.rawColumnNames[index] === this.sorterState.column ? direction : 0
            },
            iconClasses (index) {
                const state = this.getIconState(index)
                return [
                    'icon-transition position-absolute arrow-position',
                    {
                        'transparent': !state,
                        'rotate-icon': state === 'desc'
                    }
                ]
            },
            paginationChange (e) {
                this.$emit('pagination-change', Number(e.target.value))
                if (this.itemsPerPageSelect.external) {
                    return
                }
                this.perPageItems = Number(e.target.value)
            },
            objectsAreIdentical (obj1, obj2) {
                return obj1.length === obj2.length &&
                    JSON.stringify(obj1) === JSON.stringify(obj2)
            }
        }
    }
</script>

<style scoped>
    thead tr:not(:last-child) th {
        border-bottom: 1px;
    }

    .transparent {
        opacity: 0.4;
    }
    .icon-transition {
        -webkit-transition: transform 0.3s;
        transition: transform 0.3s;
    }
    .arrow-position {
        right: 0;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .rotate-icon {
        -ms-transform: translateY(-50%) rotate(-180deg);
        transform: translateY(-50%) rotate(-180deg);
    }
</style>
